import { RunCandidateScore } from "src/app/public/app/models/runCandidateScore";
import { FormalizeCompany, FormalizeRequisition, FormalizeJobMatch } from 'src/app/public/app/models/formalizePayload';
var RequisitionCardController = /** @class */ (function () {
    /*@ngInject*/
    function RequisitionCardController($rootScope, $state, $timeout, $http, $uibModal, assessmentService, genericService, StorageService, requisitionService, companyService, jobMatchService, jobService, webSocketsService, alertsAndNotificationsService, MESSAGECONSTANTS, REQUISITIONSCONSTANTS, resumeService, userRoleService) {
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.$http = $http;
        this.$uibModal = $uibModal;
        this.assessmentService = assessmentService;
        this.genericService = genericService;
        this.StorageService = StorageService;
        this.requisitionService = requisitionService;
        this.companyService = companyService;
        this.jobMatchService = jobMatchService;
        this.jobService = jobService;
        this.webSocketsService = webSocketsService;
        // this.communicationService = communicationService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
        this.REQUISITIONSCONSTANTS = REQUISITIONSCONSTANTS;
        this.resumeService = resumeService;
        this.userRoleService = userRoleService;
    }
    RequisitionCardController.prototype.$onInit = function () {
        //variables
        this.recentActivities = [];
        this.userNotificationControls = {};
        this.recentActivitiesControls = {};
        this.recentActivitiesControls.activityClickCount = 0;
        this.userNotificationControls.setNewNotificationsAsViewed = null;
        this.userNotificationControls.notificationClickCount = 0;
        this.recentActivitiesControls.getActivities = null;
        this.userId = this.$rootScope.userDetails.id;
        this.contents = [];
        this.assessmentDetails == null;
        this.valueAssessmentDetails == null;
        this.endClient = null;
        this.showpopup = false;
        this.isRequisitionCardInfoPreAvailable = true;
        //flags
        this.loadingFlag = true;
        this.isCompanyVendor = false;
        this.isCorporateCompany = false;
        this.showAdditionalDetailsFlag = false;
        this.vendorRecruitersNotAvailable = false;
        this.isActivityClicked = false;
        this.isNotificationClicked = false;
        this.isRecruitersPopoverOpen = false;
        this.isHiringManagersPopoverOpen = false;
        this.techAssessmentInfoLoading = true;
        this.valueAssessmentInfoLoading = true;
        this.isTechAssessmentInfoExists = false;
        this.isValueAssessmentInfoExists = false;
        this.jobMatchInProgress = false;
        this.init(false);
    };
    RequisitionCardController.prototype._getNoOfDaysInRequisitionState = function (requisitionStatus) {
        var today = new Date();
        var convertedUpdatedDate = new Date(moment(this.requisitionInfo.updatedDate).format("M/D/YYYY"));
        return Math.floor((today - convertedUpdatedDate) / (1000 * 3600 * 24));
    };
    RequisitionCardController.prototype._setNoOfDaysInRequisitionState = function () {
        this.noOfDaysInRequisitionState = null;
        this.noOfDaysInRequisitionStateMessage = "Number of days since Requisition updated";
        this.noOfDaysInRequisitionState = this._getNoOfDaysInRequisitionState(this.requisitionInfo.requisitionStatus);
    };
    RequisitionCardController.prototype.init = function (refresh) {
        var _this = this;
        if (!refresh) {
            this._listenToRefreshCard();
            // set the new notifications count
            this.numberOfNewNotifications = 0;
            // set notifications search object
            this.notificationsSearchObject = {};
            this.notificationsSearchObject.page = 1;
            this.notificationsSearchObject.size = 3;
            this.notificationsSearchObject.jobId = this.requisitionInfo.requisitionNumber;
            this.notificationsSearchObject.companyId = this.$rootScope.userDetails.company.companyId;
            this.notificationsSearchObject.notifyOn = 'REQUISITION_CARD';
        }
        this.showpopup = false;
        this.showAdditionalDetailsFlag = false;
        this.isRequisitionCardInfoPreAvailable = this.requisitionInfo.requisitionNumber !== undefined;
        this.options = {
            barColor: '#03a9f4',
            trackColor: '#f2f2f2',
            scaleColor: false,
            lineWidth: 8,
            size: 130,
            animate: 1500,
            onStep: function (from, to, percent) {
                $(_this.el).find('.percent').text(Math.round(percent));
            }
        };
        this.companyId = this.$rootScope.userDetails.company.companyId;
        this.isCompanyVendor = this.companyService.isCompanyVendor();
        this.isCorporateCompany = this.companyService.isCorporateCompany();
        this.isSuperUser = this.userRoleService.isLoggedInUserSuperUser();
        this.is4dot5UserAdmin = this.userRoleService.isLoggedInUser4dot5Admin();
        if (_.isNull(this.salaryDurationOptions) || !angular.isDefined(this.salaryDurationOptions)) {
            this.getSalaryDurationOptions(function () {
                if (!_this.isRequisitionCardInfoPreAvailable || refresh) {
                    _this.getRequisitionCardInfo();
                }
                else {
                    _this._massageRequisitionCardInfo(_this.requisitionInfo);
                    _this.loadingFlag = false;
                }
            });
        }
        else {
            if (!this.isRequisitionCardInfoPreAvailable || refresh) {
                this.getRequisitionCardInfo();
            }
            else {
                this._massageRequisitionCardInfo(this.requisitionInfo);
                this.loadingFlag = false;
            }
        }
    };
    RequisitionCardController.prototype._listenToRefreshCard = function () {
        var _this = this;
        this.webSocketsService.receiveWorkflowUpdate().then(null, null, function (stateChange) {
            if (stateChange.reqId == _this.requisitionInfo.requisitionNumber && stateChange.refreshJobCard) {
                console.log('Refresh requisition card', stateChange);
                if (stateChange.jobMatchInProgress) {
                    _this.jobMatchInProgress = true;
                    _this.requisitionInfo.jobMatchInProgress = true;
                }
                _this.init(true);
            }
        });
    };
    RequisitionCardController.prototype.getSalaryDurationOptions = function (successCallback) {
        var _this = this;
        this.jobService.getSalaryDurationOptions(function (data) {
            _this.salaryDurationOptions = data;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    RequisitionCardController.prototype.getRequisitionCardInfo = function () {
        var _this = this;
        this.loadingFlag = true;
        this.jobService.getRequisitionDetails(this.requisitionInfo.requisitionNumber, this.companyId, function (data) {
            _this._massageRequisitionCardInfo(data);
            _this.loadingFlag = false;
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    RequisitionCardController.prototype._setRecruitersAndHiringManagersDisplayMessage = function () {
        this.requisitionHiringManagersDisplayMessage = "";
        this.requisitionRecruitersDisplayMessage = "";
        if (this.requisitionInfo.hiringManagerDetails.length > 1) {
            var hiringManagersList_1 = [];
            this.requisitionInfo.hiringManagerDetails.map(function (hiringManager, key) {
                if (!hiringManager.isPrimary) {
                    hiringManagersList_1.push("" + (key > 0 ? " " : "") + hiringManager.name);
                }
            });
            this.requisitionHiringManagersDisplayMessage = hiringManagersList_1.toString();
        }
        if (this.recruitersCount > 0) {
            var recruiterList_1 = [];
            this.requisitionInfo.recruiters.map(function (recruiter, key) {
                recruiterList_1.push("" + (key > 0 ? " " : "") + recruiter.name);
            });
            this.requisitionRecruitersDisplayMessage = recruiterList_1.toString();
        }
    };
    RequisitionCardController.prototype._massageRequisitionCardInfo = function (data) {
        var massagedRequisitionInfo = this.requisitionService.massageRequisitionCardInfo(data, this.salaryDurationOptions);
        angular.merge(this.requisitionInfo, massagedRequisitionInfo.data);
        this.recruitersCount = massagedRequisitionInfo.recruitersCount;
        this.pocRecruiter = massagedRequisitionInfo.pocRecruiter;
        this.primaryHiringManager = massagedRequisitionInfo.primaryHiringManager;
        this.endClient = this.requisitionInfo.endClient ? this.requisitionInfo.endClient.name : this.requisitionInfo.endClient;
        this._setRequisitionGraphInfo(this.requisitionInfo);
        this._setNoOfDaysInRequisitionState();
        this._setRecruitersAndHiringManagersDisplayMessage();
        this.jobMatchInProgress = data.jobMatchInProgress;
        this.showAdditionalDetailsFlag = true;
    };
    RequisitionCardController.prototype._setRequisitionGraphInfo = function (requisitionInfo) {
        // Make the graph colour as Green if Days TO Source and Days To Fill reaches the minimum threshold days
        var optionsGreen = angular.copy(this.options);
        optionsGreen.barColor = '#8bc34a';
        // Make the graph colour as Red if no criteria matches
        var optionsRed = angular.copy(this.options);
        optionsRed.barColor = '#e84e40';
        var optionsYellow = angular.copy(this.options);
        optionsYellow.barColor = '#ffc107';
        //Make the colour as Orange
        var optionsOrange = angular.copy(this.options);
        optionsOrange.barColor = '#ff751a';
        var optionsPurple = angular.copy(this.options);
        optionsPurple.barColor = '#9c27b0';
        var optionsGray = angular.copy(this.options);
        optionsGray.barColor = '#90a4ae';
        /**
         * Check whether the requisitions are empty or not.
         * If not empty check the conditions to show DaysToSource and DaysTOFill
         */
        if (requisitionInfo.daysToSource < requisitionInfo.sourceMinValue) {
            requisitionInfo.daysToSourceGraphOptions = optionsGreen;
        }
        else if (requisitionInfo.daysToSource >= requisitionInfo.sourceMinValue && requisitionInfo.daysToSource <= requisitionInfo.sourceMaxValue) {
            requisitionInfo.daysToSourceGraphOptions = optionsOrange;
        }
        else {
            requisitionInfo.daysToSourceGraphOptions = optionsRed;
        }
        if (requisitionInfo.daysToFill < requisitionInfo.fillMinValue) {
            requisitionInfo.daysToFillGraphOptions = optionsGreen;
        }
        else if (requisitionInfo.daysToFill >= requisitionInfo.fillMinValue && requisitionInfo.daysToFill <= requisitionInfo.fillMaxValue) {
            requisitionInfo.daysToFillGraphOptions = optionsOrange;
        }
        else {
            requisitionInfo.daysToFillGraphOptions = optionsRed;
        }
        if (requisitionInfo.canEdit != null || typeof canEdit !== "undefined") {
            requisitionInfo.canEdit = this._convertToBoolean(requisitionInfo.canEdit);
        }
        if (requisitionInfo.canDelete != null || typeof canDelete !== "undefined") {
            requisitionInfo.canDelete = this._convertToBoolean(requisitionInfo.canDelete);
        }
        if (requisitionInfo.disableCompletedCandidate != null || typeof disableCompletedCandidate !== "undefined") {
            requisitionInfo.disableCompletedCandidate = this._convertToBoolean(requisitionInfo.disableCompletedCandidate);
        }
        if (requisitionInfo.disableFilledCandidate != null || typeof disableFilledCandidate !== "undefined") {
            requisitionInfo.disableFilledCandidate = this._convertToBoolean(requisitionInfo.disableFilledCandidate);
        }
        if (requisitionInfo.disableOpenState != null || typeof disableOpenState !== "undefined") {
            requisitionInfo.disableOpenState = this._convertToBoolean(requisitionInfo.disableOpenState);
        }
        if (requisitionInfo.disableCancelState != null || typeof disableCancelState !== "undefined") {
            requisitionInfo.disableCancelState = this._convertToBoolean(requisitionInfo.disableCancelState);
        }
        if (requisitionInfo.disablePausedState != null || typeof disablePausedState !== "undefined") {
            requisitionInfo.disablePausedState = this._convertToBoolean(requisitionInfo.disablePausedState);
        }
        if (requisitionInfo.disableCompleteState != null || typeof disableCompleteState !== "undefined") {
            requisitionInfo.disableCompleteState = this._convertToBoolean(requisitionInfo.disableCompleteState);
        }
        if (requisitionInfo.disableJoinState != null || typeof disableJoinState !== "undefined") {
            requisitionInfo.disableJoinState = this._convertToBoolean(requisitionInfo.disableJoinState);
        }
        if (requisitionInfo.disableFilledState != null || typeof disableFilledState !== "undefined") {
            requisitionInfo.disableFilledState = this._convertToBoolean(requisitionInfo.disableFilledState);
        }
        if (requisitionInfo.disableSourcedState != null || typeof disableSourcedState !== "undefined") {
            requisitionInfo.disableSourcedState = this._convertToBoolean(requisitionInfo.disableSourcedState);
        }
    };
    RequisitionCardController.prototype._convertToBoolean = function (value) {
        return value === "true" || value === true;
    };
    RequisitionCardController.prototype.redirectToJobWorkflow = function () {
        if (angular.isDefined(this.requisitionInfo.requisitionNumber)) {
            this.$state.go('missioncontrol.candidateJobMatchesWorkflow', {
                jobId: this.requisitionInfo.requisitionNumber,
                reqStateData: {
                    reqStateData: this.noOfDaysInRequisitionState,
                    reqStateMessage: this.noOfDaysInRequisitionStateMessage
                }
            });
        }
    };
    RequisitionCardController.prototype.redirectToUpdateRequisition = function (id) {
        this.$state.go('missioncontrol.uploadreq', { jobId: id, jobState: this.requisitionInfo.requisitionStatus, workflowSteps: this.requisitionInfo.workflowSteps, fourDotFiveIntelligentThresholdScore: this.requisitionInfo.fourDotFiveIntelligentThresholdScore, vendorsDetails: this.requisitionInfo.vendorsDetails });
    };
    RequisitionCardController.prototype.redirectToUpdateSharedReq = function (id) {
        this.$state.go('missioncontrol.editSharedReq', { jobId: id, jobState: this.requisitionInfo.requisitionStatus, corporateCompanyId: this.requisitionInfo.corporateId, buId: this.requisitionInfo.clientOrBuId, jobName: this.requisitionInfo.requisitionRole, jobType: this.requisitionInfo.jobType, requisitionInfo: this.requisitionInfo });
    };
    RequisitionCardController.prototype.showAllActivityModal = function () {
        this.requisitionService.showAllActivities(this.requisitionInfo);
    };
    RequisitionCardController.prototype.performAction = function (action) {
        var _this = this;
        if (action == 'runCandidateScore') {
            this.alertsAndNotificationsService.showConfirm('Run Candidate Score', "Are you sure you want to run the candidate score?", "warning", true, function () {
                var requestObject = new RunCandidateScore(_this.companyId, _this.userId);
                requestObject.jobId = _this.requisitionInfo.requisitionNumber;
                requestObject.rerunType = "REQUISITION";
                _this.resumeService.reRunResumeScore(requestObject, function (data) {
                    _this.alertsAndNotificationsService.showAlertWithCallBack("Candidate scoring in Progress", data.message, "success", function () { });
                }, function (error) {
                    _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                });
            }, function () {
                //do nothing
            });
        }
        else if (action == 'reRunScoringAndMatching') {
            this.alertsAndNotificationsService.showConfirm('Re-run Scoring & Matching', "Are you sure you want to Re-run Scoring & Matching?", "warning", true, function () {
                var requestObject = new RunCandidateScore(_this.companyId, _this.userId);
                requestObject.jobId = _this.requisitionInfo.requisitionNumber;
                requestObject.rerunType = "REQUISITION";
                requestObject.source = "RERUN_REMATCH";
                _this.resumeService.reRunResumeScore(requestObject, function (data) {
                    _this.alertsAndNotificationsService.showAlertWithCallBack("Re-run Scoring & Matching in Progress", data.message, "success", function () { });
                }, function (error) {
                    _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                });
            }, function () {
                //do nothing
            });
        }
        else {
            this.requisitionInfo.companyId = this.companyId;
            this.requisitionService.performAction(action, this.requisitionInfo, function () {
                _this.init(true);
            });
        }
    };
    RequisitionCardController.prototype.getRequisitionStateObject = function (stateName, requisitionObject) {
        var _this = this;
        requisitionObject.formalizeActivityPayload = {
            candidate: null,
            requisition: new FormalizeRequisition(this.requisitionInfo.requisitionNumber, this.requisitionInfo.requisitionActualNumber, this.requisitionInfo.requisitionRole),
            jobMatch: new FormalizeJobMatch(this.requisitionInfo.jobMatchId, this.requisitionInfo.requisitionNumber, this.requisitionInfo.requisitionActualNumber, this.requisitionInfo.requisitionRole),
            company: new FormalizeCompany(this.companyId, this.requisitionInfo.companyName, this.requisitionInfo.clientOrBuId, this.requisitionInfo.clientName)
        };
        this.requisitionService.performRequisitionAction(stateName, requisitionObject, this.companyId, this.copyCallback, this.deleteCallback, function () {
            _this.init(true);
        });
    };
    RequisitionCardController.prototype.showRecentActivities = function () {
        this.recentActivitiesControls.activityClickCount++;
        this.isActivityClicked = !this.isActivityClicked;
    };
    RequisitionCardController.prototype.showNotifications = function () {
        this.userNotificationControls.notificationClickCount++;
        this.isNotificationClicked = !this.isNotificationClicked;
    };
    // openCommunicationModal(recruiter, type) {
    //     this.isHiringManagersPopoverOpen = false;
    //     let user = { name: recruiter.name, email: 'recruiter@email.com'};
    //     let message = type == 'single' ? `Communicate with <span class="emerald">${user.name}</span>'` : 'Communicate ';
    //     message = `${message} regarding Requisition <span class="emerald">'${this.requisitionInfo.requisitionActualNumber}'</span> with title <span class="emerald">'${this.requisitionInfo.requisitionRole}'</span> ${this.jobService.getJobLocationInfoText(this.requisitionInfo, this.isCorporateCompany).headerInfo} via:`
    //     this.communicationService.openCommunicationModal(user, type, 'recruiter', 'requisitionCard', this.requisitionInfo, message);
    // }
    RequisitionCardController.prototype.cardMenuToggled = function (openFlag, id) {
        if (openFlag) {
            this.$timeout(function () {
                scrollIntoView(document.getElementById(id), { behavior: "smooth", block: "end", scrollMode: "if-needed" });
            }, 200);
        }
    };
    RequisitionCardController.prototype.$onDestroy = function () {
        this.webSocketsService.resetWorkflowUpdateListener();
    };
    return RequisitionCardController;
}());
RequisitionCardController.$inject = ['$rootScope', '$state', '$timeout', '$http', '$uibModal', 'assessmentService', 'genericService', 'StorageService', 'requisitionService', 'companyService', 'jobMatchService', 'jobService', 'webSocketsService', 'alertsAndNotificationsService', 'MESSAGECONSTANTS', 'REQUISITIONSCONSTANTS', 'resumeService', 'userRoleService'];
// import * as TEMPLATE from './requisition-card.html';
import * as TEMPLATE from 'raw-loader!./requisition-card.html';
export var RequisitionCardComponent = {
    selector: 'requisitionCard',
    component: {
        bindings: {
            'requisitionInfo': '<',
            'activityMap': '<',
            'isRowViewActive': '<',
            'salaryDurationOptions': '<',
            'deleteCallback': '&',
            'copyCallback': '&',
            'jobTypeList': '<'
        },
        controller: RequisitionCardController,
        // templateUrl: 'app/partials/missioncontrol/requisitions/requisitionCard/requisition-card.html'
        template: TEMPLATE.default
    }
};
//# sourceMappingURL=requisition-card.component.js.map